// Where the screw connector's user endpoints are served (the admin ones: screwConnectorAdminUrl.ts). The admin
// pages revalidate everything under it on a change, the calculator's settings included.
export const SCREW_CONNECTOR_URL = "/modules/screw_connector";

// the catalog the calculator reads, in one call (see useSettings.ts)
export const SCREW_CONNECTOR_SETTINGS_URL = `${SCREW_CONNECTOR_URL}/settings`;
